import { CallResult, doApiGet } from "./Requests";
import {
    ActionModulesDoneType,
    ActivatedAccountsType,
    AveragePointType,
    ChecklistAnswerStreakType,
    ControlSignatureMonthlyType,
    ControlSignatureWeeklyType,
    DropdownAnswerStreakType,
    EvaluationStarsType,
    EvaluationThumbsType,
    PresenceQuotaType,
    TotalPointType,
    UpcomingAnniversaryType,
    UpcomingBirthdayType
} from "../types/reportingTypes";

export const reportingApi = {
    getAveragePoints: (year: number, month: number, take: number) =>
        doApiGet<AveragePointType[]>(`/api/companies/current/employees/reporting/averagepoints/${year}/${month}?take=${take}`),

    getTotalPoints: (take: number): Promise<CallResult<TotalPointType[]>> =>
        doApiGet<TotalPointType[]>(`/api/companies/current/employees/reporting/totalpoints?take=${take}`),

    getActionModulesDone: (take: number): Promise<CallResult<ActionModulesDoneType[]>> =>
        doApiGet<ActionModulesDoneType[]>(`/api/companies/current/employees/reporting/doneactionmodules?take=${take}`),

    getPresenceQuota: (year: number, month: number): Promise<CallResult<PresenceQuotaType[]>> =>
        doApiGet<PresenceQuotaType[]>(`/api/companies/current/employees/reporting/presencequota/${year}/${month}`),

    getControlSignatureWeekly: (year: number,month: number): Promise<CallResult<ControlSignatureWeeklyType[]>> =>
        doApiGet<ControlSignatureWeeklyType[]>(`/api/companies/current/employees/reporting/controlsignature/${year}/${month}/weekly`),

    getControlSignatureMonthly: (year: number,month: number): Promise<CallResult<ControlSignatureMonthlyType>> =>
        doApiGet<ControlSignatureMonthlyType>(`/api/companies/current/employees/reporting/controlsignature/${year}/${month}/monthly`),

    getActivatedAccounts: (): Promise<CallResult<ActivatedAccountsType>> =>
        doApiGet<ActivatedAccountsType>(`/api/companies/current/employees/reporting/activatedaccounts`),

    getEvaluationStars: (startDate: string, endDate: string): Promise<CallResult<EvaluationStarsType>> =>
        doApiGet<EvaluationStarsType>(`/api/companies/current/employees/reporting/evaluationStars?startDate=${startDate}&endDate=${endDate}`),

    getEvaluationThumbs: (actionModuleId: number, startDate: string, endDate: string): Promise<CallResult<EvaluationThumbsType[]>> =>
        doApiGet<EvaluationThumbsType[]>(`/api/companies/current/employees/reporting/evaluationThumbs/${actionModuleId}?startDate=${startDate}&endDate=${endDate}`),

    getUpcomingAnniversaries: (): Promise<CallResult<UpcomingAnniversaryType>> =>
        doApiGet<UpcomingAnniversaryType>(`/api/companies/current/employees/reporting/upcomingAnniversaries`),

    getUpcomingBirthdays: (): Promise<CallResult<UpcomingBirthdayType>> =>
        doApiGet<UpcomingBirthdayType>(`/api/companies/current/employees/reporting/upcomingBirthdays`),

    getChecklistAnswerStreak: () =>
        doApiGet<ChecklistAnswerStreakType[]>(`/api/companies/current/employees/reporting/checklistAnswerStreak`),

    getDropdownAnswerStreak: () =>
        doApiGet<DropdownAnswerStreakType[]>(`/api/companies/current/employees/reporting/dropdownAnswerStreak`),
}